import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface IOtherOptions {
  data?: object;
  activeData?: object;
  changeSelection: any
}

@Component
export default class OtherOptions extends tsx.Component<IOtherOptions> {
  
  @Prop() public data!: object;
  @Prop() public activeData!: object;
  @Prop() public changeSelection!: any
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {title,price,id} = this.$props.data;
    return (
      <div  onClick={() => this.$props.changeSelection(this.$props.data)} class={`otherOptions-container ${this.$props.activeData.id === id  ? 'recommended-color' : 'default-color'}`}>
        <div class='title'>{title}</div>
        <div class='container-right'>
          <span class='actual-price'>{price / 100}</span>
          <span class='unit'>元</span>
        </div>
      </div>
    )
  }
  
}